export default __webpack_public_path__ + "static/media/copy.f58cb03a.svg";